module.exports = __webpack_public_path__ + "img/matus-min.038761bc.png";